<template>
    <div class="achievement-item">
        <div class="d-flex flex-column p-2">
            <AppIcon :src="achievement.status === 1 || achievement.status === 2 ? $store.state.treasure_icon_url : '/themes/ito/images/gem-chest-small-closed.svg'" :size="50" />
            <div class="text d-flex align-items-center justify-content-center gap-1">+{{ achievement.gem | toCommas }}
                <AppIcon :src="$store.state.gem_icon_url" :size="15" />
            </div>
        </div>
        <div class="d-flex flex-column flex-fill p-2">
            <div class="title">{{ $t(achievement.name) }} <span>({{ $t('level') }} {{ achievement.level }})</span></div>
            <div class="desc">{{ $t(achievement.desc) }}</div>
            <div class="timeline">
                <div class="timeline-1">
                    <div class="progress">
                        <div class="progress-process" :class="{ completed: achievement.status == 1 }" :style="{ width: `${achievement.progress}%` }"></div>
                    </div>
                </div>
                <div class="timeline-2">{{ achievement.process }}/{{ achievement.max_process }}</div>
            </div>
        </div>
        <div class="text-right p-2">
            <div class="complete-info" v-if="achievement.status === 2">{{ $t('complete') }} <i class="ito-icon-checked-2"></i></div>
            <button class="btn btn-ito-2-success" @click="claim(achievement)" :disabled="achievement.status === 0" v-else>{{ $t('claim') }}</button>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { claimAchievement } from "../../models/achievement";
import { soundClick, soundGetReward, soundClaimKey, soundClaimGem } from '../../utils/utils';
import AppIcon from "@/components/common/AppIcon.vue";

export default {
    name: "AchievementItem",
    components: { AppIcon },
    props: ['achievement'],

    computed: {
        ...mapGetters([
            'user_info'
        ], () => {
            if (this.user_info) {
                return this.user_info
            }

            return {
                gem: 0
            }
        }),

        configs() {
            return this.$store.state.configs
        },
    },

    methods: {
        claim(achievement) {
            const that = this;
            that.getSoundClaimGem();

            claimAchievement({
                id: achievement.id
            }).then((response) => {
                if (response.data.code != 0) {
                    return;
                }

                that.achievement.status = response.data.results.status || '';

                const new_gem = response.data.results.update_gem || 0;
                const new_gem_month = response.data.results.gem_month || 0;
                const gem = response.data.results.gem_reward || 0;

                that.user_info.gem = new_gem;
                that.user_info.gem_month = new_gem_month;

                const gem_txt = gem > 0 ? '+' + gem : gem;

                this.$emit('updateMission', {
                    updateMission: 1
                })

                $('#congratulation_gem').text(gem_txt);
                $('#getRewardedModal').modal('show');
                //location.reload();
            }).catch(({ response }) => {
                console.error(response);
            });
        },
        getSoundClick() {
            soundClick();
        },

        getSoundGetReward() {
            soundGetReward();
        },

        getSoundClaimKey() {
            soundClaimKey();
        },

        getSoundClaimGem() {
            soundClaimGem();
        }
    }
}
</script>

<style scoped>
.text {
    font-weight: 700;
    font-size: 12px;
    line-height: 19px;
    color: #1B1B1B;
    text-align: center;
}

.title {
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 22px;
    letter-spacing: 0.02em;
    color: #070A28;
}

.timeline {
    display: flex;
    align-items: center;
}

.timeline-1 {
    width: -webkit-fill-available;
}

.timeline-2 {
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 19px;
    letter-spacing: 0.02em;
    color: rgba(7, 10, 40, 0.6);
    margin-left: 11px;
    flex: 1;
}

.title>span {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 19px;
    letter-spacing: 0.02em;
    color: #070A28;
}

.desc {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 19px;
    letter-spacing: 0.02em;
    color: rgba(7, 10, 40, 0.6);
}
</style>